import DecisionNodeBase from '~/models/journey/DecisionNodeBase'
import type { WaypointNode } from '~/models/journey/waypoints'
import type { Path } from '~/types/util'
import { SessionStore } from '~/stores/session'
import { PlanType } from '~/generated/api-clients-generated'
import { EngineStore } from '~/stores/engine'

export class IsMsPlanTypeNode extends DecisionNodeBase {
  getNext(): WaypointNode | Path | null {
    const session = SessionStore.use()
    const engine = EngineStore.use()

    const planType = engine.selectedPlanType ?? session.planType

    return this.yesNo(planType === PlanType.GAP)
  }
}
